import React, { FC, MouseEvent, PropsWithChildren } from 'react';
import { Button as Wrapper } from './styles';
import { Brand } from 'static/theme/brand';
import Icon from 'components/atoms/Icon';
import colors from 'static/theme/colors';
import { Icons } from 'static/theme/icons';

export interface RoundButtonProps {
    onClick?: () => void;
    brand?: keyof Brand;
    className?: string;
    loading?: boolean;
    type?: 'button' | 'submit';
    tabIndex?: number;
    noFocus?: boolean;
    icon: keyof Icons;
    size?: 'md' | 'lg';
    // Variants.
    disabled?: boolean;
    white?: boolean;
    transparent?: boolean;
}

const RoundButton: FC<PropsWithChildren<RoundButtonProps>> = ({ loading, disabled, onClick, children, brand = 'blue', size = 'md', type, white, transparent, ...props }) => {

    // Methods.
    const handleOnClick = (event?: MouseEvent) => {
        if (onClick && (!loading || disabled)) {
            onClick();
        }
    };

    // Render.
    return (
        <Wrapper disabled={disabled || loading} onClick={handleOnClick} type={type} brand={brand} white={white} size={size} transparent={transparent} {...props}>
            <Icon name={props.icon} color={(transparent || white) ? colors.dark : colors.white} size={1} />
        </Wrapper>
    );
};

export default RoundButton;
